import isNumber from 'lodash/isNumber'
import React, { FC } from 'react'
import { Column, ColumnType } from '../../../models/column'
import classNames from 'classnames'
import useTableTranslation from '@components/UI-Components/HierarchyWiseItemsTable/hooks/use-table-translation'
import { CentricTypography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'
import { stores } from '@stores'
import { View } from '@modules/order/constants/views'

export interface CellProps {
  column?: Column
}

interface PrivateCellProps {
  stickyPosition?: number
  enhancedViewCell?: boolean
  noCellBackground?: boolean
}

const useStyles = makeStyles(theme => ({
  headerCell: {
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    height: '100%',
    zIndex: 9,
    '&.enhancedHeaderCellOverride:last-of-type .listViewTableGroupCellOverride .customBorderOverride:after':
      {
        borderRight: '0px'
      }
  },
  enhancedHeaderCell: {
    backgroundColor: '#eeeeee',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
    height: '100%',
    zIndex: 9,
    '&.enhancedHeaderCellOverride:last-of-type .listViewTableGroupCellOverride .customBorderOverride:after':
      {
        borderRight: '0px'
      }
  },
  enhancedHeaderCellWithNoBackground: {
    background: 'inherit'
  },
  enhancedStickyHeader: {
    borderRight: '2px solid #ccc !important',
    boxShadow: 'none'
  },
  enhancedStickyCell: {
    borderRight: '2px solid #ccc !important'
  },
  enhancedCellBorder: {
    borderRight: '1px solid #ccc'
  },
  leftBorder: {
    borderLeft: '1px solid #ccc'
  },
  stickyCell: {
    position: 'sticky',
    zIndex: 10
  },
  cellBorder: {
    borderRight: '1px solid #ededed'
  },
  headerCellContent: {
    margin: 'auto',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  enhancedHeaderText: {
    width: '100%',
    textAlign: 'center'
  },
  customBorder: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      borderRight: '2px #ccc solid',
      right: 0,
      height: '50%',
      marginTop: 'auto',
      marginBottom: 'auto'
    },
    '&:last-of-type:after': {
      content: 'none'
    }
  }
}))
const Cell: FC<CellProps & PrivateCellProps> = ({
  column,
  stickyPosition,
  enhancedViewCell,
  noCellBackground
}) => {
  const classes = useStyles()
  const {
    headerCellElement: HeaderCellElement,
    label,
    showHeader = true,
    isStickyBorder = false,
    width,
    showBorders = false,
    showHeaderBorder = false,
    showHeaderRightBorder = false,
    className,
    key,
    type
  } = column
  const { t } = useTableTranslation()
  const {
    productConfiguration: { enhancedViewEnabled },
    nav: {
      queryParams: { view }
    }
  } = stores

  const applyCustomPipeBorder =
    (enhancedViewCell && !isNumber(stickyPosition) && !isStickyBorder) ||
    (view === View.KPI && enhancedViewEnabled && !isStickyBorder)
  return (
    <div
      className={classNames(
        enhancedViewCell || (view === View.KPI && enhancedViewEnabled)
          ? classes.enhancedHeaderCell
          : classes.headerCell,
        'enhancedHeaderCellOverride',
        {
          [classes.stickyCell]: isNumber(stickyPosition),
          [classes.cellBorder]:
            !enhancedViewCell &&
            !enhancedViewEnabled &&
            (showBorders || showHeaderBorder),
          [classes.enhancedStickyCell]:
            enhancedViewCell && key && isNumber(stickyPosition),
          [classes.enhancedCellBorder]:
            enhancedViewCell && !key && (showBorders || showHeaderBorder),
          [classes.enhancedStickyHeader]: showHeaderRightBorder,
          [classes.enhancedHeaderCellWithNoBackground]: noCellBackground,
          [classes.customBorder]: applyCustomPipeBorder
        },
        className
      )}
      style={{
        width: width || '100%',
        minWidth: width,
        left: stickyPosition
      }}
    >
      {showHeader ? (
        HeaderCellElement ? (
          <HeaderCellElement column={column} />
        ) : enhancedViewEnabled ? (
          <CentricTypography
            variant={type !== ColumnType.Grouped ? 'subtitle2DarkGrey' : 'subtitle2'}
            className={classNames(classes.headerCellContent, classes.enhancedHeaderText)}
          >
            {key ? t(`order.listview.colHeader.${key}`, label) : label}
          </CentricTypography>
        ) : (
          <span className={classes.headerCellContent}>
            {key ? t(`order.listview.colHeader.${key}`, label) : label}
          </span>
        )
      ) : null}
    </div>
  )
}

export default Cell
